// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing237({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle10
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/223/01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/237/02.jpg`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/237/03.jpg`}
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        qTitleColor="#10542d"
        qOptionColor="darkteal"
        formFieldColor="white"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/green/applyButton2.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      />
    </>
  );
}
export default Randing237;
